<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form
      :model="formData"
      ref="detailInfo"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card" v-model="selectLang">
        <el-tab-pane
          :name="item.name"
          :label="$t('message.' + item.name)"
          v-for="(item, index) in langList"
          :key="index"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Type </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="type"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-select v-model="formData.type" @change="handleUpdateSelect">
                      <el-option
                        v-for="typeItem in typeList"
                        :key="typeItem.key"
                        :label="typeItem.name"
                        :value="typeItem.key">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> District Name </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="item.districtName"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="formData[item.districtName]"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" v-if="formData.type=='2'">
                <label class="col-sm-2 control-label"> Address </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="item.addressName"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="formData[item.addressName]"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Mobile Number </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="mobileNum"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="formData.mobileNum"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" v-if="formData.type=='2'">
                <label class="col-sm-2 control-label"> Fax </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="faxNum"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="formData.faxNum"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button @click="handleSubmit" type="primary"
                      >Save</el-button
                    >
                    <el-button @click="handleBack">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import axios from "axios";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      id: "",
      formData: {
        type:1,
        districtNameEn: "",
        districtNameSc: "",
        districtNameTc: "",
        mobileNum: "",
        faxNum:0,
        addressEn: "",
        addressSc: "",
        addressTc: ""
      },
      selectLang: "en_US",
    };
  },
  computed: {
    langList(){
        return [
            {name:"en_US",districtName:"districtNameEn",addressName:"addressEn"},
            {name:"zh_CN",districtName:"districtNameSc",addressName:"addressSc"},
            {name:"zh_HK",districtName:"districtNameTc",addressName:"addressTc"}
        ]
    },
    typeList(){
      return [
        {name:"Police Community Relations Office",key:1},
        {name:"Junior Police Call Clubhouse",key:2}
      ]
    },
    baseURL() {
      return config.domain + "/";
    },
    userInfo() {
      return this.getAuthObj();
    },
  },

  created() {
    this.id = this.$route.query.id;
    if (this.id) this.intiPage();
  },
  mounted() {},
  methods: {
    handleUpdateSelect(){
      this.$forceUpdate()
    },
    async intiPage() {
      const param = {
        ...this.userInfo,
        id: this.id,
      };
      const {
        data: { result, status_code, status_message },
      } = await axios.post(this.baseURL + "district/getDetail", param);
      if (status_code == "0") {
        Object.assign(this.formData,result)
        this.formData.type = this.formData.type || 1
      } else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },

    async handleSubmit() {
       this.$refs["detailInfo"].validate(async (valid) => {
        if (valid) {
          const param = {
            ...this.formData,
            ...this.userInfo,
          };
          if (this.id) param.id = this.id;
          const {
            data: { status_code, status_message },
          } = await axios.post(
            this.baseURL +
              (this.id
                ? "district/update"
                : "district/add"),
            param
          );
          if (status_code == "0") {
          } else {
            this.$store.getters.warning.warningMsg = status_message;
            this.$store.getters.warning.warningFalg = true;
          }
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>
